var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mp-skeleton-data-list"},_vm._l((_vm.dataList),function(data,index){return _c('ul',{key:index},[_c('li',{class:index !== 0 && index % 5 === 0 && index !== _vm.dataList.length
          ? 'dataItem dataItem_divider'
          : 'dataItem'},[_c('div',{staticClass:"dot_title"},[_vm._v("·")]),_c('div',{staticClass:"content_title"}),_c('div',{staticClass:"time"})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }